<!-- HISTORY: has this.log(msg, showAlert)
   V260811.1: Consumed the newly added is-association-type-changed prop of bt-apps.
   V260209.1: Removed the App Endpoint from the expanded item for security reasons.
   V251217.1: 1st version/release (Was copied from CsActions.vue to use the new apps endpoint instead of mixins/cs-apps.js).
-->
<!--TODO:
- Clear instruction textfield in appChanged()
- Make sure that ENDPOINT_PATTERN works fine for all cases
- Pass associationType to the apps UI (<component>)
- Make save btn in edit disabled until the 1st change.
-->
<!-- BUSINESS LOGIC:
   actions={
      name: Joi.string().min(5).max(250).required(),
      appCode: Joi.string().valid(process.env.APP_CODES.split(',').join(',')).required(),
      appType: Joi.string().valid('outbound','inbound', 'both').required(),
      inboundAssociatedField: Joi.string(),
      inboundRecordLookup: Joi.string(), //{ filter:{ cell: "{to}" } , findValueIn: "body|query" }
      inboundRecordLookupScope: Joi.string(), //this is offer filter without aggregation which will be merged with inboundRecordLookup
      consumerCode: Joi.string().min(32).max(36).required(),
      instruction: Joi.object().required(),
      appEndpoint:
      associationType: Joi.array().required().min(1).max(3)
   }
   apps = {
      // type, typeDesc, componentName => n/a
      "code <= value": "100",
      "name <= text": "IVision SMS",
      "actionTypes <= hasExportAssociation & hasTriggerAssociation": [
         "export", "trigger", "inbound"
      ],
      "iframeURL": {
         "staging": "https://portal-stg.mindfiresupport.com/SMSUI.html",
         "production <= onProduction": "https://portal-stg.mindfiresupport.com/SMSUI.html"
      },
      "eventSource": ["api" | "bulk" | "js-sdk"],
      "icon": "",
      "events": [
         { "code": "10001", "label": "Delivered to provider" },
         { "code": "10003", "label": "Click", "hookable": true }
      ],
      "sharedWith": {
         "aids": [],
         "paids": [],
         "email": []
      }
   }
-->
<template>
<v-container fluid class="px-3 py-3">
   <v-card>
      <v-card-title class="pl-2 pb-2">
         <h1 class="title font-weight-bold grey--text darken-4 pl-2" style="color:#757575 !important">
            <v-icon class="pr-2 pb-2">connect_without_contact</v-icon>
            <span>Actions</span>
         </h1>
         <div class="flex-grow-1"></div>
         <v-btn v-if="canCreate"
            x-small
            class="mr-2 mt-1"
            color="gray darken-1"
            :disabled="loadingItems"
            @click="newItemClicked()"
         >NEW ACTION
            <v-icon right dark>add</v-icon>
         </v-btn>
      </v-card-title>
      <v-card-text class="py-0">
         <bt-filter-wrapper-with-panel
            :closed-on-load="true"
            :fields="searchFields"
            :included-tabs="['standard']"
            :is-admin="jwt.pa"
            :max="searchFields.length"
            :preselected-fields="[]"
            :should-init="shouldInitFilterDefiner"
            :std-field-values="searchFieldsValues"
            v-model="filter"
            @filter-change="filterChanged"
         ></bt-filter-wrapper-with-panel>
      </v-card-text>
      <v-card-text class="pt-2">
         <v-data-table dense fixed-header show-expand single-expand
            class="elevation-1"
            item-key="name"
            :footer-props="{
               itemsPerPageOptions: [5, 10, 20],
               showFirstLastPage: true
            }"
            :headers="headers"
            :hide-default-footer="itemsCount <= 5"
            :items="items"
            :items-per-page="5"
            :loading="loadingItems"
            :loading-text="$t('loading-text')"
            :no-data-text="$t('no-data-text', { value: 'items' })"
            :no-results-text="$t('no-results-text', { value: 'items' })"
            :options.sync="options"
            :search="search"
            :server-items-length="itemsCount"
         >
            <template v-slot:[`item.appCode`]="{ item }">
               {{ getAppText(item.actualAppCode) }}
            </template>
            <template v-slot:[`item.appType`]="{ item }">
               <v-icon>{{getAppTypeIcon(item.appType)}}</v-icon>
               <span> {{ getAppTypeDesc(item.appType) }}</span>
            </template>
            <template v-slot:[`item.associationType`]="{ item }">
               {{ item.associationType.join(', ') }}
            </template>
            <template v-slot:[`item.createdAt`]="{ item }">
               {{ formatDate(item.createdAt, true) }}
            </template>
            <template v-slot:[`item.action`]="{ item }">
               <v-icon v-if="canEdit"
                  small
                  @click="editItemClicked(item)"
               >edit</v-icon>
               <!-- <v-icon v-if="canDelete"
                  small
                  @click="deleteItem(item)"
               >delete</v-icon> -->
            </template>
            <template v-slot:expanded-item="{ item }">
               <td colspan="7" class="py-2" valign="top" dense>
                  <ul>
                     <li>
                        <span class="expanded-header">Instruction: </span>
                        <span class="expanded-content">{{item.instruction}}</span>
                     </li>
                     <!--V260209: <li v-if="item.appEndpoint.trim()">
                        <span class="expanded-header">App Endpoint: </span>
                        <span class="expanded-content">{{item.appEndpoint}}</span>
                     </li> -->
                     <!-- <li v-if="item.appType != 'outbound'">
                        <span class="expanded-header">Inbound Associated Field: </span>
                        <span class="expanded-content">{{item.inboundAssociatedField}}</span>
                     </li>
                     <li v-if="item.appType != 'outbound'">
                        <span class="expanded-header">Inbound Record Lookup: </span>
                        <span class="expanded-content">{{item.inboundRecordLookup}}</span>
                     </li>
                     <li v-if="item.appType != 'outbound'">
                        <span class="expanded-header">Inbound Record Lookup Scope: </span>
                        <span class="expanded-content">{{item.inboundRecordLookupScope}}</span>
                     </li> -->
                     <li>
                        <span class="expanded-header">ID: </span>
                        <span class="expanded-content">{{item._id}}</span>
                     </li>
                  </ul>
               </td>
            </template>
         </v-data-table>
      </v-card-text>
   </v-card>

   <v-dialog v-if="currItem"
      no-click-animation persistent
      max-width="960px"
      v-model="mainDialog"
   >
      <v-form lazy-validation
         ref="mainForm"
         v-model="isMainFormValid"
      >
         <v-card flat class="px-3">
            <v-card-title class="title grey--text darken-4 font-weight-bold pb-2">
               {{currItem._id ? `Edit Action '${currItem.name}':` : 'Create a New Action:'}}
            </v-card-title>
            <v-card-text
               class="pb-0"
               :loading="loadingNewItem"
            >
               <v-row>
                  <v-col xs="12" sm="12" :md="appColSize" class="py-0">
                     <v-autocomplete persistent-hint required return-object
                        ref="app"
                        placeholder="select an app..."
                        :disabled="Boolean(currItem._id)"
                        hint="* App"
                        item-text="name"
                        item-value="code"
                        :items="userApps"
                        :rules="[rules.required]"
                        v-model="formData.app"
                        @change="appChanged"
                     ></v-autocomplete>
                  </v-col>
                  <v-col v-if="formData.app.code" xs="12" sm="12" md="5" class="py-0">
                     <v-autocomplete multiple persistent-hint required small-chips deletable-chips
                        ref="associationType"
                        autocomplete="off"
                        :class="formData.app.associationType.length ? 'pt-3' : 'pt-4'"
                        placeholder="select an association type..."
                        hint="* Association Types"
                        :items="associationTypeItems"
                        :rules="[rules.requiredArray]"
                        v-model="formData.app.associationType"
                        @change="associationTypeChanged"
                     ></v-autocomplete>
                  </v-col>
                  <v-col v-if="hasAssociation" xs="12" sm="12" md="3" class="py-0">
                     <v-select disabled persistent-hint
                        hint="* App Type"
                        :items="appTypeItems"
                        v-model="formData.app.type"
                     ></v-select>
                  </v-col>
               </v-row>

               <v-row v-if="hasAssociation" class="pt-3">
                  <v-col cols="12" class="py-0">
                     <v-text-field counter persistent-hint required
                        ref="name"
                        autocomplete="off"
                        placeholder="enter a name or description with 5 to 150 chars"
                        hint="* Name"
                        :rules="[rules.required, rules.nameLen, rules.duplicateName]"
                        v-model="formData.name"
                     ></v-text-field>
                  </v-col>
               </v-row>

               <!-- <v-row v-if="hasAssociation && !currItem._id && formData?.app?.type && formData?.app?.type != 'outbound'">
                  <v-col xs="12" sm="12" md="12" class="pt-0 pb-2">
                     <v-text-field counter persistent-hint required
                        ref="inboundAssociatedField"
                        autocomplete="off"
                        placeholder="specify the associated field name"
                        hint="* Inbound Associated Field"
                        :rules="[rules.required]"
                        v-model="formData.inboundAssociatedField"
                     ></v-text-field>
                  </v-col>
               </v-row>
               <v-row v-if="hasAssociation && !currItem._id && formData?.app?.type && formData?.app?.type != 'outbound'">
                  <v-col xs="12" sm="12" md="12" class="pt-5 pb-0">
                     <v-textarea dense outlined persistent-hint
                        readonly
                        class="py-0 my-0 caption"
                        ref="scope"
                        rows="4"
                        placeholder="to be implemented... (filter's $match value)"
                        hint="* Inbound Record Lookup Scope"
                        v-model="formData.inboundRecordLookupScope"
                     ></v-textarea>
                  </v-col>
               </v-row> -->
               <v-row v-if="hasAssociation">
                  <v-col xs="12" sm="12" md="12" class="py-0 pr-0">
                     <v-card flat class="pt-2 pb-0">
                        <v-card-title class="mx-0 my-0 px-0 py-0">
                           <div class="flex-grow-1"></div>
                           <!-- :iframe-url="currApp.iframeURL[environment]" -->
                           <!-- iframe-url="/bt-sendgrid-email.html" -->
                           <!-- V260811: Consumed the newly added is-association-type-changed prop -->
                           <bt-apps
                              :app-name="formData.app.name"
                              :association-type="formData.app.associationType"
                              :is-association-type-changed="!isAppInstructionsSaved"
                              :debug="debug"
                              :iframe-url="currApp.iframeURL[environment]"
                              v-model="formData.appInstructions"
                              @change="appInstructionsChanged"
                           />
                        </v-card-title>
                     </v-card>
                  </v-col>
               </v-row>
               <v-row v-show="hasAssociation">
                  <v-col xs="12" sm="12" md="12" class="py-0">
                     <v-textarea dense outlined persistent-hint readonly required
                        class="py-0 my-0 caption"
                        ref="strAppInstructions"
                        rows="4"
                        hint="* Instruction"
                        placeholder="click on the menu icon (3-dot) above this box to configure the action..."
                        :rules="[rules.required, rules.validJson]"
                        :error-messages="instructionErrMsg"
                        v-model="formData.strAppInstructions"
                     ></v-textarea>
                  </v-col>
               </v-row>
            </v-card-text>

            <v-card-actions>
               <div class="flex-grow-1"></div>
               <v-btn text small
                  class="px-0"
                  color="blue darken-1"
                  @click="closeMainDialog"
               >Cancel</v-btn>
               <v-btn text small
                  class="px-0 mx-0"
                  color="blue darken-1"
                  :disabled="!formData.app.code || !isMainFormValid"
                  @click="saveItem"
               >Save</v-btn>
            </v-card-actions>
         </v-card>
      </v-form>
   </v-dialog>

   <v-overlay :value="overlay">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
   </v-overlay>
</v-container>
</template>

<script>
import BtFilterWrapperWithPanel from './BtFilterWrapperWithPanel.vue';
import BtApps from './BtApps.vue';
import { APIService } from '../services/cs-api-service.js';
import { format, parseISO } from "date-fns";
import { getAppList } from '../mixins/cs-apps.js';
import { isAppSharedWithUser, toPascalCase } from '../mixins/bt-mixin.js';

class FormData {
   constructor(initVal ={}, app ={}) {
      this.name = initVal.name || '';

      this.app = {};
      Object.keys(this.app).forEach(key => delete this.app[key]);
      this.app = JSON.parse(JSON.stringify(app));

      this.app.associationType = initVal.associationType || [];

      this.appInstructions = {};
      Object.keys(this.appInstructions).forEach(key => delete this.appInstructions[key]);
      if (initVal.instruction) {
         this.appInstructions.instruction = initVal.instruction;
         this.strAppInstructions = JSON.stringify(initVal.instruction);
      } else {
         this.strAppInstructions = '';
      }

      this.appEndpoint = initVal.appEndpoint?.trim() || '';
   }
}

const NAME = 'CsActionsV2';
const VERSION = 'V260811.1';
const ENDPOINT_PATTERN = /^(https?:\/\/)?([\w.-]+)(:\d{1,5})?(\/[\w\-./?%&=]*)?$/;
const TRAILING_NUMBER_PATTERN = /\s\((\d{1,2})\)$/;
const _areArraysEqual = (a1, a2) => {
   return a1.length === a2.length &&
      [...a1].sort().join() === [...a2].sort().join();
};

export default {
   name: NAME,

   components: {
      BtFilterWrapperWithPanel,
      BtApps
   },

   props: {
      debug: {
         type: Boolean,
         default: false
      },

      isActualEndpoint: {
         type: Boolean,
         default: true
      }
   },

   data() {
      return {
         rules: {
            required: value => !!value || "Value is required!",
            requiredArray: value => !!value.length || "Value is required!",
            nameLen: value => (value?.trim().length >= 5 && value?.trim().length <= 150) || "Value should have 5 to 150 chars!",
            consumerCodeLen: value => (value?.trim().length >= 32 && value?.trim().length <= 36) || "Value should have 32 to 36 chars!",
            duplicateName: value => {
               const action = this.items.find(item => item.name.toLowerCase() === value.toLowerCase().trim());
               if (action)
                  return action._id === this.currItem._id || 'Value is duplicate!';
               else return true;
            },
            validJson: value => {
               try {
                  const obj = JSON.parse(value);
                  return (
                     obj &&
                     typeof obj === "object" &&
                     !Array.isArray(obj) &&
                     Object.keys(obj).length > 0 &&  // Ensure it has properties
                     Object.values(obj).some(val => val !== null && val !== '' && val !== undefined) // Ensure at least one non-empty value
                  ) || "Invalid JSON: Must have at least one property with a value.";
               } catch (error) {
                  return error.toString();
               }
            },
            endpoint: value => ENDPOINT_PATTERN.test(value?.trim()) || "Value is invalid!"
         },
         headers: [
            { text: 'Name', value: 'name', align: 'left', sortable: true },
            { text: 'App', value: 'appCode', align: 'left', sortable: true },
            { text: 'App Type', value: 'appType', align: 'left', sortable: true },
            { text: 'Association Types', value: 'associationType', align: 'left', sortable: true },
            { text: 'Author', value: 'author', align: 'left', sortable: true },
            { text: 'Creation Date', value: 'createdAt', align: 'left', sortable: true },
            { text: 'Actions', value: 'action', align: 'right', sortable: false }
         ],
         searchFields: [
            { text: 'Name', value: 'name', type: 'string', isIndexed: true },
            { text: 'App Code', value: 'appCode', type: 'string', isIndexed: true },
            { text: 'App Type', value: 'appType', type: 'string', isIndexed: true },
            { text: 'Author', value: 'author', type: 'string', isIndexed: true  }
         ],
         appTypeItems: [
            { text: 'Outbound', value: 'outbound' },
            { text: 'Inbound', value: 'inbound' },
            { text: 'Inbound/Outbound', value: 'both' }
         ],
         appItems: [],
         userApps: [],
         jwt: {},
         apiService: null,
         filter: {
            standard: [{ $match: {} }]
         },
         searchFieldsValues: null,
         itemsCount: 0,
         items: [],
         options: {},
         search: '',
         loadingItems: true,
         loadingNewItem: false,
         mainDialog: false,
         isMainFormValid: false,
         shouldInitFilterDefiner: false,
         currItem: null,
         formData: {},
         overlay: false,
         associationTypeItems: [],
         hasAssociation: false,
         currApp: null,
         isAppInstructionsSaved: false,
         lastAssociations: [],
         instructionErrMsg: '',
         appsFromSettings: []
      }
   },

   computed: {
      environment() {
         return process.env.VUE_APP_EDGE_SERVICE_ENDPOINT.includes('services.mdl.io')
            ? 'production' : 'staging';
      },

      token() {
         return this.$store.getters.token;
      },

      canCreate() {
         return this.$store.getters.user.policies && this.$store.getters.user.policies.includes('contact-action-create');
      },

      canEdit() {
         return this.$store.getters.user.policies && this.$store.getters.user.policies.includes('contact-action-update');
      },

      canDelete() {
         return this.$store.getters.user.policies && this.$store.getters.user.policies.includes('contact-action-delete');
      },

      appColSize() {
         return this.formData.app.code ? 4 : 12;
      },

      canManageSendgridUsers() {
         return (this.isActualEndpoint && this.jwt.email === 'btalebpour@mindfireinc.com') || this.jwt.email === 'daver+webinar@mindfireinc.com';
      }
   },

   watch: {
      token() {
         this.init();
         this.nextAction();
      },

      options: {
         handler (val) {
            if (val.sortBy.length > 0) {
               const sort = {};
               sort[val.sortBy[0]] = val.sortDesc[0] ? -1 : 1;
               this.filter.sort = sort;
            }
            this.getItems();
         }
      },

      isAppInstructionsSaved: {
         handler (val) {
            if (val)
               this.instructionErrMsg = '';
            else if (this.formData.strAppInstructions)   //V260811: this.formData.app?.code?.startsWith('703') && 
               this.instructionErrMsg = 'Value needs to be updated!';
         }
      }
   },

   methods: {
      log(msg, showAlert) {
         if (this.debug) {
            console.log(`-----${NAME} ${VERSION} says => ${msg}`);
            if (showAlert)
               alert(`-----${NAME} ${VERSION} says => ${msg}`);
         }
      },

      logout() {
         this.$router.push('/');
      },

      async init() {
         try {
            this.items = [];

            if (this.token) {
               // user, email, pa, pu, aid, paid, exp
               this.jwt = JSON.parse(Buffer.from(this.token.split('.')[1], 'base64'));
               // this.log(`in ${NAME}.init(): jwt=${JSON.stringify(this.jwt)}`);
               this.apiService = new APIService(this.jwt, this.token, this.debug, this.isActualEndpoint);
               await this.getItemsCount();
               const resSettings = await this.apiService.getSettings();
               if (resSettings.logout)
                  this.logout();

               const apps = resSettings.data.apps || {};
               this.appsFromSettings = getAppList(
                  this.jwt.email,
                  this.$store.getters.user.preferences.apps || [],
                  apps.genericApps || []
               )
               // .map(item => {
               //    const { text, value, ...otherProps } = item;
               //    return {
               //       name: text,
               //       code: value,
               //       ...otherProps
               //    };
               // });
               .map(({ text, value, ...rest }) => ({
                  name: text,
                  code: value,
                  ...rest
               }));

               const resApps = await this.apiService.getAppsWithActionTypes();
               if (resApps.logout)
                  this.logout();

               this.appItems = resApps.data.map(d => ({
                     ...d,
                     name: `${d.name} (${d.code})`
                  }));

               // alert(`in ${NAME}.init(): appItems=${JSON.stringify(this.appItems)}`);

               this.searchFieldsValues = {
                  appCode: this.appItems.map(d => { return { text: d.name, value: d.code } }),
                  appType: this.appTypeItems
               };

               const user = {
                  aid: this.jwt.aid,
                  paid: this.jwt.paid,
                  email: this.jwt.email
               };

               this.userApps = this.appItems.filter(item => isAppSharedWithUser(item.sharedWith, user));
               this.shouldInitFilterDefiner = true;
            } else {
               this.jwt = {};
               this.appItems = [];
               this.userApps = [];
               this.searchFieldsValues = null;
            }
         } catch (error) {
            alert('Exception while parsing token: ' + error.message);
         }
      },

      async getItemsCount() {
         this.loadingItems = true;
         let result = await this.apiService.getActionsCount(this.filter);
         if (result.logout)
            this.logout();

         this.itemsCount = result.message ? 0 : result.data;
         this.loadingItems = false;
      },

      async getItems() {
         this.loadingItems = true;
         let result = await this.apiService.getActions(this.filter, this.options.itemsPerPage, this.options.page);
         if (result.logout)
            this.logout();
         else if (result.message)
            this.items = [];
         else {
            this.items = result.data.map(item => {
               const match = item.name.match(TRAILING_NUMBER_PATTERN);
               const suffix = match ? `-${match[1].padStart(2, '0')}` : '';
               const name = item.name.replace(TRAILING_NUMBER_PATTERN, '');
               return {
                  ...item,
                  name,
                  actualAppCode: item.appCode + suffix
               };
            });
            this.$forceUpdate();
         }
         this.loadingItems = false;
      },

      getAppText(appCode) {
         const app = [...this.appItems, ...this.appsFromSettings].find(item => item.code === appCode);
         const appName = app?.name || 'Unknown';
         return appName.endsWith(`(${appCode})`) ? appName : `${appName} (${appCode})`;
      },

      getAppTypeDesc(appType) {
         return this.appTypeItems.find(t => t.value === appType).text || appType;
      },

      getAppTypeIcon(appType) {
         switch (appType) {
            case 'outbound':
               return 'output';
            case 'inbound':
               return 'input';
            case 'both':
               return 'sync_alt';
            default:
               return '';
         }
      },

      formatDate(date, withTime) {
         if (date) {
            // alert('in formatDate(): date='+date+'\nwithTime=' + withTime + '\nparseISO='+parseISO(date));
            const formattedDate = format(parseISO(date), 'M/d/yyyy h:mm:ss a');
            if (withTime) return formattedDate;
            else return formattedDate.split(' ')[0];
         }
      },

      async filterChanged(filter) {
         // alert('in filterChanged(): filter=' + JSON.stringify(filter) + '\noptions=' + JSON.stringify(this.options));
         this.filter = filter;
         await this.getItemsCount();
         this.nextAction();
      },

      async nextAction() {
         const currOptions = JSON.stringify(this.options);
         const newOptions = JSON.parse(currOptions);
         newOptions.page = 1;
         if (JSON.stringify(newOptions) === currOptions)
            await this.getItems();
         else
            this.options = newOptions;
      },

      async newItemClicked() {
         this.currItem = {};
         this.formData = new FormData();
         this.lastAssociations = [];
         this.isAppInstructionsSaved = false;
         this.mainDialog = true;
         setTimeout(() => {
            this.$refs?.app?.focus();
         }, 10);
      },

      async editItemClicked(item) {
         // alert(`in editItemClicked(): item=${JSON.stringify(item)}`);
         this.currItem = JSON.parse(JSON.stringify(item));
         this.currApp = this.appItems.find(item => item.code === this.currItem.actualAppCode);
         this.formData = new FormData(this.currItem, this.currApp);
         this.lastAssociations = [...this.formData.app.associationType];
         this.isAppInstructionsSaved = true;
         this.mainDialog = true;
         this.appChanged(this.currApp);
      },

      async appChanged(selectedApp) {
         // alert('in appChanged(): selectedApp=' + JSON.stringify(selectedApp));
            if (!this.currItem._id) {
               this.formData.app = JSON.parse(JSON.stringify(selectedApp));
            }

            this.currApp = JSON.parse(JSON.stringify(selectedApp));
            this.appTypeChanged(selectedApp.actionTypes);

            //TODO: it gave error: Error in beforeMount hook: "TypeError: Cannot read properties of undefined (reading 'find')"
            const this2 = this;
            setTimeout(() => {
               // this2.$refs?.mainForm?.validate();
               this2.$refs?.associationType?.focus();
            }, 10);
      },

      associationTypeChanged(val) {
         // alert(`in associationTypeChanged(): val=${val?.join(',')}`);
         this.isAppInstructionsSaved = _areArraysEqual(val, this.lastAssociations);

         if (val.length) {
            this.hasAssociation = true;
            if (val.includes('inbound'))
               this.formData.app.type = val.length === 1 ? 'inbound' : 'both';
            else
               this.formData.app.type = 'outbound';

            // alert(this.formData.app.type)

            // if (this.formData.app.type != 'inbound') {
            //    const ph = [];
            //    if (val.includes('export')) ph.push('export');
            //    if (val.includes('trigger')) ph.push('trigger');
            // }

            // // setTimeout(() => {
            // //    this.$refs?.name?.focus();
            // // }, 10);
         } else {
            this.hasAssociation = false;
            this.formData.app.type = '';
         }
      },

      appTypeChanged(associationType) {
         // alert(`in appTypeChanged(): associationType=${JSON.stringify(associationType)}`);
         this.associationTypeItems = associationType.map(association =>
         {
            return {
               text: toPascalCase(association),
               value: association
            }
         });

         if (!this.currItem._id) {
            this.formData.app.associationType = [];
            if (this.associationTypeItems.length === 1) {
               this.formData.app.associationType.push(this.associationTypeItems[0].value);
            }
         }

         this.associationTypeChanged(this.formData.app.associationType);
      },

      appInstructionsChanged(val) {
         // alert(`in appInstructionsChanged(): val=${JSON.stringify(val)}`);
         this.formData.appInstructions = val;
         this.formData.strAppInstructions = JSON.stringify(val.instruction);
         this.lastAssociations = [...this.formData.app.associationType];
         this.isAppInstructionsSaved = true;
      },

      async saveItem() {
         if (!this.$refs.mainForm.validate()) return;

         this.loadingNewItem = true;
         const appCodeParts = this.getAppCodeParts();

         const actionData = {
            name: this.formData.name.trim() + appCodeParts.seq,
            associationType: this.formData.app.associationType
         };

         actionData.instruction = this.formData.appInstructions.instruction;
         const { consumerCode, appEndpoint } = this.formData.appInstructions;

         let result;
         if (this.currItem._id) {
            if (this.formData.app.type != this.currItem.appType)
               actionData.appType = this.formData.app.type;

            if (appEndpoint != this.currItem.appEndpoint)
               actionData.appEndpoint = appEndpoint;

            // alert('actionData=' + JSON.stringify(actionData))
            result = await this.apiService.updateAction(this.currItem, actionData);
            if (result.logout)
               this.logout();
            else if (!result.message)
               this.$emit('snackbar-event', `The '${this.formData.name}' Action was updated.`);
         } else {
            actionData.appCode = appCodeParts.code;
            actionData.appType = this.formData.app.type;
            actionData.consumerCode = consumerCode;
            actionData.appEndpoint = appEndpoint

            // alert('actionData=' + JSON.stringify(actionData))
            result = await this.apiService.createAction(actionData);
            if (result.logout)
               this.logout();
            else if (!result.message) {
               this.$emit('snackbar-event', `The new '${this.formData.name}' Action was created.`);
               this.itemsCount++;
            }
         }

         if (!result.message) {
            await this.nextAction();
            this.closeMainDialog();
            this.loadingNewItem = false;
         }
      },

      getAppCodeParts() {
         const result = {};
         const appCodeParts = this.formData.app.code.split('-');
         result.code = appCodeParts[0];
         if (appCodeParts.length === 2) {
            const appCodeSeq = appCodeParts[1][0] === '0' ? appCodeParts[1][1] : appCodeParts[1];
            result.seq = ` (${appCodeSeq})`;
         } else
            result.seq = '';

         return result;
      },

      closeMainDialog() {
         this.mainDialog = false;
         this.currItem = null;
         this.hasAssociation = false;
      },

      async deleteItem(item) {
         if (confirm(`Are you sure to delete '${item.name}'?`)) {
            this.loadingItems = true;
            this.overlay = true;
            const result = await this.apiService.deleteAction(item._id);
            if (result.logout)
               this.logout();
            else if (!result.message) {
               this.$emit('snackbar-event', `The '${item.name}' Action was deleted.`);
               this.itemsCount--;
               await this.nextAction();
            }
            this.overlay = false;
            this.loadingItems = false;
         }
      }
   },

   created() {
      this.init();
   }
}
</script>

<style scoped>
.v-text-field input {
   padding: 4px 0 8px;
}
.expanded-header {
   font-style: italic;
   font-weight: bold;
}
</style>